<template>
  <div id="body_app">
      <main-gallery class="mt-0"></main-gallery>
  </div>
</template>

<script>

import MainGallery from "./MainGallery";

export default {
  name: 'app',
  components: {
    MainGallery,
  }
}
</script>

<style>

  body, html {
      /* background-color: #000; */
      /* background: linear-gradient(white, 40%, black) !important; */
      background: -webkit-gradient(linear, left top, left bottom, from(white), to(black)) fixed;
      background-repeat: no-repeat;
      background-attachment: fixed; 
      color: #fff;
      /* width: 100%; */
      height: 100%;
      margin: 0;
      padding: 0;
  }

  .row {
    width: 100%; 
    margin: 0px;
  }

  .side_img {
    position: absolute;
    top: 10%;
    opacity: 0.5;
    width: 120px;
    height: auto;
  }
  .side_img-l {
      left: 0px;
      /* margin-left: -50px; */
  }
    .side_img-r {
      right: 0px;
      /* margin-right: -50px; */
  }

</style>
